import { AttributeRecord, DataEntryRowRecord } from 'components/table/useDataEntriesInTables';

export const ProfitabilityStatus = {
  HEALTHY: 'healthy',
  AT_RISK: 'atRisk',
  CRITICAL: 'critical',
} as const;

export type ProfitabilityStatus = (typeof ProfitabilityStatus)[keyof typeof ProfitabilityStatus];

export type SupportedAttributeCode = 'prdCategory' | 'chnMarketplace' | 'chnCountry';

export interface ProfitabilityDrillDownRow extends AttributeRecord {
  netSoldGmv: number;
  cogRate: number;
  cm1Rate: number;
  feeRate: number;
  logCstRate: number;
  cm2Val: number;
  cm2Rate: number;
  status: ProfitabilityStatus;
}

export interface StatusColumn {
  status: ProfitabilityStatus;
}

export interface LensRow extends DataEntryRowRecord, StatusColumn {}
export interface ProfitabilityBreakdownRow extends DataEntryRowRecord, StatusColumn {}

export interface ProfitabilityDrillDownData {
  rows: ProfitabilityDrillDownRow[];
}

export interface ProfitabilityStatusCounts {
  atRiskCount: number;
  atRiskCountPrev: number;
  criticalCount: number;
  criticalCountPrev: number;
}

export interface RankedMoverRow extends DataEntryRowRecord {
  entityType: SupportedAttributeCode;
  entityValue: string;
}

export interface RankedMoversData {
  gainers: RankedMoverRow[];
  decliners: RankedMoverRow[];
}
